const jsonToolsActionTypes = {
  SET_JSON_TOOL_VALUES: "SET_JSON_TOOL_VALUES",
  REMOVE_JSON_TOOL_VALUES: "REMOVE_JSON_TOOL_VALUES",
  SIGNOUT_SUCCESS: "SIGNOUT_SUCCESS",
};

export default jsonToolsActionTypes;
